import { render, staticRenderFns } from "./restrictions.vue?vue&type=template&id=f256d0f8&"
import script from "./restrictions.vue?vue&type=script&lang=js&"
export * from "./restrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports